import en from './locales/en'
import th from './locales/th'
import jp from './locales/jp'
import kr from './locales/kr'
import zhHans from './locales/zhHans'
import zhHant from './locales/zhHant'
import userEn from './locales/en/user'
import userTh from './locales/th/user'
import navWindowEn from './locales/en/navWindow'
import navWindowTh from './locales/th/navWindow'
import navNodeEn from './locales/en/navNode'
import navNodeTh from './locales/th/navNode'
import labOrderOrderItemEn from './locales/en/labOrderOrderItem'
import labOrderOrderItemTh from './locales/th/labOrderOrderItem'
import loginEn from './locales/en/login'
import loginTh from './locales/th/login'
import pathologistListEn from './locales/en/pathologistList'
import pathologistListTh from './locales/th/pathologistList'
import webOrderEn from './locales/en/webOrder'
import webOrderTh from './locales/th/webOrder'
import pathoOnlineEn from './locales/en/pathoOnline'
import pathoOnlineTh from './locales/th/pathoOnline'
import pathoOnlineJp from './locales/jp/pathoOnline'
import pathoOnlineKr from './locales/kr/pathoOnline'
import pathoOnlineZhHans from './locales/zhHans/pathoOnline'
import pathoOnlineZhHant from './locales/zhHant/pathoOnline'
import PathoRegisterMLCEn from './locales/en/PathoRegisterMLC'
import PathoRegisterMLCTh from './locales/th/PathoRegisterMLC'
import PathoRegisterMLCBlockEn from './locales/en/PathoRegisterMLCBlock'
import PathoRegisterMLCBlockTh from './locales/th/PathoRegisterMLCBlock'
import PathoRegisterMLCSelectEn from './locales/en/PathoRegisterMLCSelect'
import PathoRegisterMLCSelectTh from './locales/th/PathoRegisterMLCSelect'
import PathoRegisterIHCEn from './locales/en/PathoRegisterIHC'
import PathoRegisterIHCTh from './locales/th/PathoRegisterIHC'
import PathoRegisterIHCSlideEn from './locales/en/PathoRegisterIHCSlide'
import PathoRegisterIHCSlideTh from './locales/th/PathoRegisterIHCSlide'
import PathoRegisterIHCSelectEn from './locales/en/PathoRegisterIHCSelect'
import PathoRegisterIHCSelectTh from './locales/th/PathoRegisterIHCSelect'
import PathoStatisticReport01En from './locales/en/PathoStatisticReport01'
import PathoStatisticReport01Th from './locales/th/PathoStatisticReport01'
import PathoReportResendEn from './locales/en/PathoReportResend'
import PathoReportResendTh from './locales/th/PathoReportResend'
import PathoRegisterSpecialStainEn from './locales/en/PathoRegisterSpecialStain'
import PathoRegisterSpecialStainTh from './locales/th/PathoRegisterSpecialStain'
import PathoRegisterSpecialStainSlideEn from './locales/en/PathoRegisterSpecialStainSlide'
import PathoRegisterSpecialStainSlideTh from './locales/th/PathoRegisterSpecialStainSlide'
import PathoRegisterSpecialStainSelectEn from './locales/en/PathoRegisterSpecialStainSelect'
import PathoRegisterSpecialStainSelectTh from './locales/th/PathoRegisterSpecialStainSelect'
import PathoRegisterMLCSlideTh from './locales/th/PathoRegisterMLCSlide'
import PathoRegisterMLCSlideEn from './locales/en/PathoRegisterMLCSlide'
import PathoRegisterReportTh from './locales/th/PathoRegisterReport'
import PathoRegisterReportEn from './locales/en/PathoRegisterReport'
import WpLabRequestTh from './locales/th/WpLabRequest'
import WpLabRequestEn from './locales/en/WpLabRequest'
import WpLabRequestMm from './locales/mm/WpLabRequest'
import WpLabReceiveTh from './locales/th/WpLabReceive'
import WpLabReceiveEn from './locales/en/WpLabReceive'
import WpLabResultTh from './locales/th/WpLabResult'
import WpLabResultEn from './locales/en/WpLabResult'
import WpAcctInvoicesTh from './locales/th/WpAcctInvoices'
import WpAcctInvoicesEn from './locales/en/WpAcctInvoices'
import apiClientManagementEn from './locales/en/ApiClientManagement'
import apiClientManagementTh from './locales/th/ApiClientManagement'
import protocolManagementEn from './locales/en/ProtocolManagement'
import protocolManagementTh from './locales/th/ProtocolManagement'
import DriverManagementEn from './locales/en/DriverManagement'
import DriverManagementTh from './locales/th/DriverManagement'
import WpCustomerEn from './locales/en/WpCustomer'
import WpCustomerTh from './locales/th/WpCustomer'
import WpResultItemTh from './locales/th/WpResultItem'
import WpResultItemEn from './locales/en/WpResultItem'
import WpOrderItemTh from './locales/th/WpOrderItem'
import WpOrderItemEn from './locales/en/WpOrderItem'
import WpTestItemTh from './locales/th/WpTestItem'
import WpTestItemEn from './locales/en/WpTestItem'
// Object.keys(user).forEach(function (item) {
//   Object.assign(en, {item: user[item]})
// })

// _.merge(en, user)

// Object.assign(en, userEn)
// Object.assign(th, userTh)
// Object.assign(en, navWindowEn)
// Object.assign(th, navWindowTh)
// Object.assign(en, navNodeEn)
// Object.assign(th, navNodeTh)

en['navWindow'] = navWindowEn
th['navWindow'] = navWindowTh
en['user'] = userEn
th['user'] = userTh
en['navNode'] = navNodeEn
th['navNode'] = navNodeTh
en['labOrderOrderItem'] = labOrderOrderItemEn
th['labOrderOrderItem'] = labOrderOrderItemTh
en['login'] = loginEn
th['login'] = loginTh
en['pathologistList'] = pathologistListEn
th['pathologistList'] = pathologistListTh
en['webOrder'] = webOrderEn
th['webOrder'] = webOrderTh
en['pathoOnline'] = pathoOnlineEn
th['pathoOnline'] = pathoOnlineTh
jp['pathoOnline'] = pathoOnlineJp
kr['pathoOnline'] = pathoOnlineKr
zhHans['pathoOnline'] = pathoOnlineZhHans
zhHant['pathoOnline'] = pathoOnlineZhHant
en['PathoStatisticReport01'] = PathoStatisticReport01En
th['PathoStatisticReport01'] = PathoStatisticReport01Th
en['PathoRegisterMLC'] = PathoRegisterMLCEn
th['PathoRegisterMLC'] = PathoRegisterMLCTh
en['PathoRegisterMLCSelect'] = PathoRegisterMLCSelectEn
th['PathoRegisterMLCSelect'] = PathoRegisterMLCSelectTh
en['PathoRegisterMLCBlock'] = PathoRegisterMLCBlockEn
th['PathoRegisterMLCBlock'] = PathoRegisterMLCBlockTh
en['PathoRegisterIHC'] = PathoRegisterIHCEn
th['PathoRegisterIHC'] = PathoRegisterIHCTh
en['PathoRegisterIHCSelect'] = PathoRegisterIHCSelectEn
th['PathoRegisterIHCSelect'] = PathoRegisterIHCSelectTh
en['PathoRegisterIHCSlide'] = PathoRegisterIHCSlideEn
th['PathoRegisterIHCSlide'] = PathoRegisterIHCSlideTh
en['PathoReportResend'] = PathoReportResendEn
th['PathoReportResend'] = PathoReportResendTh
en['PathoRegisterSpecialStain'] = PathoRegisterSpecialStainEn
th['PathoRegisterSpecialStain'] = PathoRegisterSpecialStainTh
en['PathoRegisterSpecialStainSelect'] = PathoRegisterSpecialStainSelectEn
th['PathoRegisterSpecialStainSelect'] = PathoRegisterSpecialStainSelectTh
en['PathoRegisterSpecialStainSlide'] = PathoRegisterSpecialStainSlideEn
th['PathoRegisterSpecialStainSlide'] = PathoRegisterSpecialStainSlideTh
en['PathoRegisterMLCSlide'] = PathoRegisterMLCSlideEn
th['PathoRegisterMLCSlide'] = PathoRegisterMLCSlideTh
th['PathoRegisterReport'] = PathoRegisterReportTh
en['PathoRegisterReport'] = PathoRegisterReportEn
en['WpLabRequest'] = WpLabRequestEn
th['WpLabRequest'] = WpLabRequestTh
en['WpLabReceive'] = WpLabReceiveEn
th['WpLabReceive'] = WpLabReceiveTh
en['WpLabResult'] = WpLabResultEn
th['WpLabResult'] = WpLabResultTh
en['WpAcctInvoices'] = WpAcctInvoicesEn
th['WpAcctInvoices'] = WpAcctInvoicesTh
en['ApiClientManagement'] = apiClientManagementEn
th['ApiClientManagement'] = apiClientManagementTh
en['ProtocolManagement'] = protocolManagementEn
th['ProtocolManagement'] = protocolManagementTh
en['DriverManagement'] = DriverManagementEn
th['DriverManagement'] = DriverManagementTh
en['WpCustomer'] = WpCustomerEn
th['WpCustomer'] = WpCustomerTh
en['WpOrderItem'] = WpOrderItemEn
th['WpOrderItem'] = WpOrderItemTh
en['WpResultItem'] = WpResultItemEn
th['WpResultItem'] = WpResultItemTh
en['WpTestItem'] = WpTestItemEn
th['WpTestItem'] = WpTestItemTh
export default {
  en,
  th,
  jp,
  kr,
  zhHans,
  zhHant,
}
